import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Block = (props) => {
  const { children, colourScheme, heading, customPadding } = props;
  const componentClasses = classNames('block', {
    [`block--${colourScheme}`]: colourScheme,
    [`block--${customPadding}`]: customPadding
  });

  return (
    <section className={componentClasses}>
      <div className="block__inner">
        {heading && (
          <div className="block__heading">
            {heading.img && <img src={heading.img} alt={heading.alt} />}
            <div className="block__text">
              <h2 className="block__title">{heading.title}</h2>
              {heading.subtitle && <p className="block__subtitle">{heading.subtitle}</p>}
              {heading.mobileBio && (
                <p className="block__subtitle block__subtitle--hide-desktop">{heading.mobileBio}</p>
              )}
            </div>
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

Block.propTypes = {
  children: PropTypes.node,
  colourScheme: PropTypes.oneOf(['neutral-navy']),
  heading: PropTypes.object,
  customPadding: PropTypes.oneOf(['no-top', 'no-bottom', 'no-padding'])
};

export default Block;
